/**
 * Parse a cityId coming from an untrusted source (query param, cookie) into a
 * valid positive integer, or undefined. Guards against the values a mangled
 * campaign link or the app itself can produce: 'abc', 'null' (posters-slider
 * interpolates a null city for visitors without one), '' (Number('') === 0),
 * and repeated params (arrays).
 */
export function parseCityId(value: unknown): number | undefined {
  const cityId = Number(value);
  return Number.isInteger(cityId) && cityId > 0 ? cityId : undefined;
}
